<template>
  <div class="tracking-events" data-testid="tracking-events">
    <div class="tracking-events-label" v-if="title">{{ title }}</div>
    <ul
      class="event-timeline list-unstyled mb-0"
      :style="{ maxHeight: maxHeight }"
      v-if="sortedEvents.length > 0"
    >
      <li class="event-item" v-for="(ev, evIdx) in sortedEvents" :key="ev.externalEventId || evIdx">
        <div class="small font-weight-bold">{{ ev.eventStatus || ev.eventType }}</div>
        <div class="small text-muted">
          {{ ev.eventAtDateTimeUtc | moment('MMM D, YYYY h:mm A') }}
          <span v-if="ev.location"> &middot; {{ ev.location }}</span>
        </div>
        <div class="small" v-if="ev.details">{{ ev.details }}</div>
      </li>
    </ul>
    <div class="small text-muted" v-else>{{ emptyText }}</div>
  </div>
</template>

<script>
/**
 * Tracking events timeline (newest first), for Shipment.events / OrderReturn.events.
 */
export default {
  name: 'TrackingEvents',
  props: {
    events: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    maxHeight: { type: String, default: '320px' },
    emptyText: { type: String, default: 'No tracking events yet.' }
  },
  computed: {
    sortedEvents() {
      return (this.events || []).slice().sort(function(a, b) {
        return new Date(b.eventAtDateTimeUtc) - new Date(a.eventAtDateTimeUtc);
      });
    }
  }
};
</script>

<style scoped>
.tracking-events-label {
  margin-bottom: 0.25rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #73818f;
}
.event-timeline {
  margin-top: 0.5rem;
  padding-left: 0.25rem;
  overflow-y: auto;
}
.event-item {
  position: relative;
  padding: 0 0 0.75rem 1rem;
  border-left: 2px solid #c8ced3;
}
.event-item:last-child {
  padding-bottom: 0;
}
.event-item::before {
  content: '';
  position: absolute;
  left: -6px;
  top: 0.3rem;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #20a8d8;
}
</style>
